<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside width="210px" class="sidebar">
      <div class="logo">
        <div class="logo-icon"><img src="@/assets/logo.jpg" alt="logo" /></div>
        <div class="logo-text">
          <span class="logo-name">白玉口腔 · 后台</span>
          <span class="logo-sub">优惠券运营管理</span>
        </div>
      </div>
      <el-menu
          :key="menuList.length"
          :default-active="activeMenu"
          :default-openeds="openedMenus"
          background-color="#1e2a3a"
          text-color="#a3b1c6"
          active-text-color="#ffffff"
          router
          class="side-menu"
      >
        <template v-for="menu in menuList">
          <el-submenu
              v-if="menu.children && menu.children.length"
              :index="menu.path"
              :key="menu.id"
              :class="{ 'is-menu-active': isMenuActive(menu) }"
          >
            <template slot="title">
              <i v-if="menu.icon" :class="menu.icon"></i>
              <span>{{ menu.menuName }}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :index="child.path" :key="child.id">
              <i v-if="child.icon" :class="child.icon"></i>
              <span slot="title">{{ child.menuName }}</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :index="menu.path" :key="menu.id" :class="{ 'is-menu-active': isMenuActive(menu) }">
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶栏 -->
      <el-header class="header">
        <div class="header-left">
          <i class="el-icon-location-outline"></i>
          <span class="page-title">{{ $route.meta.title || '工作台' }}</span>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <span class="user-avatar">{{ userInfo ? ((userInfo.realName || userInfo.username) || '').charAt(0) : '管' }}</span>
              <span class="user-name">{{ userInfo ? (userInfo.realName || userInfo.username) : '' }}</span>
              <i class="el-icon-arrow-down el-icon--right" style="color:#909399" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">
                <i class="el-icon-switch-button" style="color:#f56c6c" /> 退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="main-area">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getMenusByRoleId } from '@/api/menu'

export default {
  name: 'Layout',
  data() {
    return {
      menuList: []
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    // 当前路由所属的父级菜单，用于刷新后自动展开
    openedMenus() {
      const path = this.$route.path
      const opened = []
      this.menuList.forEach(menu => {
        if (menu.children && menu.children.some(child => child.path === path)) {
          opened.push(menu.path)
        }
      })
      return opened
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },

  async created() {
    // 1. 等待用户信息获取完成
    await this.$store.dispatch('getUserInfo')

    // 2. 此时 roleId 一定有值
    const roleId = localStorage.getItem('roleId')
    console.log('✅ roleId =', roleId)

    // 3. 获取菜单
    this.loadMenuTree(roleId)
  },

  methods: {

    async loadMenuTree(roleId) {
      if (!roleId) {
        console.error(' roleId 为空')
        return
      }

      try {
        const res = await getMenusByRoleId(roleId)
        this.menuList = res.data || []
        // 将菜单数据保存到 Vuex，同时提取权限标识
        this.$store.dispatch('setMenus', this.menuList)
      } catch (error) {
        console.error('获取菜单失败', error)
      }
    },

    // 判断菜单是否应显示选中高亮
    isMenuActive(menu) {
      const path = this.$route.path
      // 1. 路由严格等于菜单路径，或路由以菜单路径为前缀
      if (path === menu.path || path.startsWith(menu.path + '/')) {
        return true
      }
      // 2. 子菜单中有任何一项匹配当前路由
      if (menu.children && menu.children.length) {
        return menu.children.some(c => path === c.path || path.startsWith(c.path + '/'))
      }
      return false
    },

    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;

  .sidebar {
    background: linear-gradient(180deg, #1e2a3a 0%, #16202e 100%);
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 8px rgba(0, 21, 41, 0.08);
    z-index: 10;

    .logo {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 0 12px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.06);

      .logo-icon {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .logo-text {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
        min-width: 0;
      }
      .logo-name {
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
      }
      .logo-sub {
        color: #6b7f99;
        font-size: 10px;
        margin-top: 2px;
        letter-spacing: 1px;
      }
    }

    .side-menu {
      flex: 1;
      border-right: none;
      overflow-y: auto;
      background: transparent;
      padding: 8px 10px;

      // 所有菜单项 & 父菜单标题：基础样式 + hover
      ::v-deep .el-menu-item,
      ::v-deep .el-submenu__title {
        height: 44px;
        line-height: 44px;
        border-radius: 8px;
        margin-bottom: 2px;
        transition: all 0.2s;

        i {
          color: #6b7f99;
          margin-right: 8px;
          transition: color 0.2s;
        }
        &:hover {
          background-color: rgba(74, 144, 217, 0.15) !important;
          color: #fff !important;
          i { color: #4A90D9; }
        }
      }

      // 顶层激活统一样式：独立菜单项 & 父级菜单标题
      ::v-deep .is-menu-active.el-menu-item,
      ::v-deep .el-submenu.is-menu-active > .el-submenu__title,
      ::v-deep .el-submenu.is-active > .el-submenu__title {
        background: linear-gradient(135deg, #4A90D9, #2E6FB7) !important;
        color: #fff !important;
        box-shadow: 0 4px 10px rgba(74, 144, 217, 0.35);
        i { color: #fff; }
      }

      // 子菜单容器透明
      ::v-deep .el-submenu .el-menu {
        background: transparent !important;
      }
      // 子菜单项基础样式
      ::v-deep .el-submenu .el-menu .el-menu-item {
        padding-left: 46px !important;
        font-size: 13px;
      }
      // 子菜单项激活：轻量高亮（左侧指示条 + 浅色背景）
      ::v-deep .el-submenu .el-menu .el-menu-item.is-active {
        background-color: rgba(74, 144, 217, 0.2) !important;
        color: #fff !important;
        box-shadow: none;
        border-left: 3px solid #4A90D9;
        i { color: #4A90D9; }
      }
    }
  }

  .header {
    background: #fff;
    box-shadow: 0 1px 6px rgba(0, 21, 41, 0.06);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 60px;
    z-index: 9;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #4A90D9;
      font-size: 16px;
      .page-title {
        color: #1d2129;
        font-size: 15px;
        font-weight: 600;
      }
    }

    .header-right {
      cursor: pointer;

      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        outline: none;

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: linear-gradient(135deg, #4A90D9, #2E6FB7);
          color: #fff;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .user-name {
          color: #1d2129;
          font-size: 14px;
        }
      }
    }
  }

  .main-area {
    background: linear-gradient(180deg, #eef1f6, #f0f4f8);
    padding: 0;
  }
}
</style>
